// DEBOOK-1890 — la web solo admite admins. El rechazo lo hace el servidor
// en pocketbase/hooks/admin-only-auth.pb.js con un 403; aquí solo se
// traduce el código al mensaje que ve la persona. Una contraseña
// incorrecta llega como 400, así que los dos casos no se solapan.

const ADMIN_ONLY =
  'Esta cuenta no tiene acceso. The 3333 Games está reservado al equipo de administración.';
const INACTIVE = 'Tu cuenta está desactivada. Habla con el equipo.';
const INVALID = 'Email o contraseña incorrectos';

function statusOf(err: unknown): number | undefined {
  if (typeof err !== 'object' || err === null || !('status' in err)) {
    return undefined;
  }
  const { status } = err as { status?: unknown };
  return typeof status === 'number' ? status : undefined;
}

export function loginErrorMessage(err: unknown): string {
  if (statusOf(err) === 403) return ADMIN_ONLY;
  if (err instanceof Error && err.message === 'Cuenta desactivada') {
    return INACTIVE;
  }
  return INVALID;
}
